/**
 * PATH: packages/email-hub/src/feature/reader-header/adapters/PreviewReaderHeaderAdapter.tsx
 * FILE_ID: EMAILHUB-READERHEADER-ADAPTER-PREVIEW-001
 * PURPOSE: Enforce preview-surface invariants over the shared adapter frame.
 * ROLE IN ARCHITECTURE: Public adapter the preview host mounts (plan Phase 1).
 * MAIN EXPORTS: PreviewReaderHeaderAdapter, PreviewReaderHeaderAdapterProps.
 * NON-RESPONSIBILITIES: No zoom (full view only); no compose dock ownership.
 * NOTES FOR FUTURE AI: `onExpand` is REQUIRED — preview must always hand off
 *   to full view preserving the selected email (registry `expand` visibility).
 */
import { ReaderHeaderAdapter } from './ReaderHeaderAdapter'
import type { ReaderHeaderHostBindings } from './types'

export type PreviewReaderHeaderAdapterProps = Omit<
  ReaderHeaderHostBindings,
  'surface' | 'zoom' | 'onExpand'
> & {
  /** Hand off to full view preserving the selected email. */
  onExpand: () => void
}

export function PreviewReaderHeaderAdapter(
  props: PreviewReaderHeaderAdapterProps,
) {
  return <ReaderHeaderAdapter {...props} surface="preview" />
}
